/**
 * Guard for hypothesis-run summaries. Runs that died mid-stream may have a
 * raw tool payload (JSON blob) captured as the summary — a legacy backend bug
 * whose rows still exist. Cards render the no-summary fallback for these
 * instead of dumping JSON at the user.
 */
export function summaryLooksLikeRawPayload(summary: string | null | undefined): boolean {
  return !!summary && summary.trimStart().startsWith('{')
}

/**
 * Plain-text rendering of a run summary for compact excerpts. The backend
 * strips inline markdown for new runs, but legacy rows still carry
 * `**bold**` and `[F#]`/`[S#]` citation markers from the report.
 */
export function plainSummaryExcerpt(summary: string): string {
  return summary
    .split('\n')
    .filter(line => !line.trimStart().startsWith('|'))
    .join('\n')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/\[(?:F|S)\d+\]/g, '')
    .replace(/ {2,}/g, ' ')
    .trim()
}
